import type { $Fetch } from 'ofetch';
import type { PoloGateway, ListPolosParams } from '@/application/port/out/PoloGateway';
import type { Polo, UpsertPoloCommand } from '@/domain/model/Polo';
import type { Page } from '@/domain/model/Page';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const ROOT = '/api/v1/polos';

/** HTTP gateway do CRUD de Polo. Authority BE: `org:polo:read|create|update|manage`. */
export class HttpPoloGateway implements PoloGateway {
  constructor(private readonly client: $Fetch) {}

  async list(params: ListPolosParams): Promise<Page<Polo>> {
    const query: Record<string, string | number> = { page: params.page, size: params.size };
    if (params.name) query.name = params.name;
    const res = await this.client<ApiResponse<Page<Polo>>>(ROOT, { method: 'GET', params: query });
    assertApiSuccess(res);
    return res.data;
  }

  async get(id: string): Promise<Polo> {
    const res = await this.client<ApiResponse<Polo>>(`${ROOT}/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: UpsertPoloCommand): Promise<Polo> {
    const res = await this.client<ApiResponse<Polo>>(ROOT, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: UpsertPoloCommand): Promise<Polo> {
    const res = await this.client<ApiResponse<Polo>>(`${ROOT}/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async deactivate(id: string): Promise<Polo> {
    // BE retorna 200 + a entidade desativada (não 204) — usa o envelope.
    const res = await this.client<ApiResponse<Polo>>(`${ROOT}/${encodeURIComponent(id)}`, { method: 'DELETE' });
    assertApiSuccess(res);
    return res.data;
  }
}
